import React, {useState} from 'react';
import {Typography} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import bitImage from '../../assets/bit.jpg'
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {getPaymentPageLink} from "../../api";
import ButtonBase from "@material-ui/core/ButtonBase";
import PaymentIcon from "@material-ui/icons/Payment";
import PaymentForm from "../PaymentForm";
import CircularProgress from "@material-ui/core/CircularProgress";
import {reduxForm} from "redux-form";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {ADD_NOTIFICATION} from "../../store/action";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            width: '250px',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(3),
        },
        backButton: {
            position: 'absolute',
            top:'10px',
            left:'10px',
            transform: 'rotate(180deg)'
        },
        paying_box: {
            width: '200px',
            // border: `1px solid ${theme.palette.primary.main}`,עיסוי
            borderRadius: '5px',
            margin: '15px 0',
            padding: theme.spacing(2),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            boxShadow: `0px 0px 5px 1px ${theme.palette.primary.main}`
        }

    }
});
const PaymentOptions = ({formValues, change, onSubmit, paymentId, handleBack, dispatch, supplierId}) => {
    const {t} = useTranslation()
    const {activity: {heName: activityName, duration, price}, dateAndTime, customer: {phone, name: {heName: customerName}}} = formValues;
    const classes = useStyles();
    const [iframeUrl, setIframeUrl] = useState(null)
    const [showLoading, setShowLoading] = useState(null)
    const activityDescription = `${activityName} - ${duration} ${t('min')}`
    const fetchPaymentUrl = (paymentMethod) => {
        setShowLoading(paymentMethod)
        getPaymentPageLink({
            description: activityDescription,
            fullName: customerName,
            phone: phone,
            sum: price,
            paymentMethod,
            paymentId,
            supplierId
        }).then(({data: {url, processId}}) => {
            if(!url){
                dispatch({
                    type: ADD_NOTIFICATION,
                    payload: {
                        type: 'error',
                        text: t('general-error')
                    }
                })
            }
            setIframeUrl(url)
            change('processId', processId)
            setShowLoading(null)
        })
    }

    return <div className={classes.root}>
        {!iframeUrl ? <>
                <ButtonBase className={classes.backButton} onClick={handleBack}><ArrowBackIcon
                    color={'primary'}/></ButtonBase>
                <div className={"details"}>

                    <Typography variant={'h1'} color={'primary'} align={'center'}
                                gutterBottom={true}>{activityDescription}</Typography>
                    <Typography variant={'h2'} color={'primary'} align={'center'}
                                gutterBottom={true}>{`${t('pay')} ${price}$`}</Typography>
                    <Typography variant={'h3'} align={'center'}
                                gutterBottom={true}>{moment(dateAndTime).format('HH:MM D.M')}</Typography>
                </div>
                <ButtonBase className={classes.paying_box} onClick={() => fetchPaymentUrl('bit')}>
                    <Typography variant={'h2'} color={'primary'} align={'center'} gutterBottom={true}>לתשלום עם
                        ביט</Typography>
                    {showLoading === 'bit' ? <CircularProgress size={'80px'} color={'primary'}/> :
                        <img src={bitImage} alt={"לתשלום עם ביט"} width={'80px'}/>}
                </ButtonBase>
                <ButtonBase className={classes.paying_box} onClick={() => fetchPaymentUrl('creditCard')}>
                    <Typography variant={'h2'} color={'primary'} align={'center'} gutterBottom={true}>לתשלום בכרטיס
                        אשראי</Typography>
                    {showLoading === 'creditCard' ? <CircularProgress size={'80px'} color={'primary'}/> :
                        <PaymentIcon style={{fontSize: 80}} color={'primary'}/>}
                </ButtonBase>
            </>
            : <PaymentForm url={iframeUrl} onFailed={() => {
                setIframeUrl(null)
            }} onSuccess={() => {
                onSubmit(formValues)
            }}/>}
    </div>
}

const PaymentOptionsWithRedux = reduxForm({
    form: 'bookingAppointmentWizard',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(PaymentOptions);

const mapStateToProps = (state) => ({
    formValues: state.form.bookingAppointmentWizard?.values,
    paymentId: state.general?.supplier?.personalData.paymentId,
    supplierId: state.general?.supplier?.personalData._id
})

export default connect(mapStateToProps)(PaymentOptionsWithRedux);